// Identidade da instância (vem do ambiente — nunca chumbar nome de clínica no código).
export const CLINIC_NAME = process.env.REACT_APP_CLINIC_NAME || 'Painel administrativo'
